<div class="dashboard-content" *ngIf="isLoaded">

  <div class="client-title-wrapper">
    <div class="title">
      <h2>профиль</h2>
      <div class="client-name-wrapper">
        <h1>{{user.firstName}}  {{user.secondName}} {{user.lastName}}</h1>
<!--        <span class="lnr lnr-pencil in-square"></span>-->
      </div>

      <!--  (click)="openEditPopup()"-->

    </div>



    <div class="current-balance-wrapper">
<!--      <span class="label">Текущий баланс:</span>-->
      <span class="amount">
        <span [ngClass]="{'amount-positive': user.balance?.uah > 0,
                 'amount-negative': user.balance?.uah < 0,
                 'amount-zero': user.balance?.uah == 0}"
        >  {{user.balance?.uah | cost:'UAH'}} / </span>
        <span [ngClass]="{'amount-positive': user.balance?.usd > 0,
                 'amount-negative': user.balance?.usd < 0,
                 'amount-zero': user.balance?.usd == 0}"
        > {{user.balance?.usd | cost:'USD'}} / </span>
        <span [ngClass]="{'amount-positive': user.balance?.eur > 0,
                 'amount-negative': user.balance?.eur < 0,
                 'amount-zero': user.balance?.eur == 0}"
        > {{user.balance?.eur | cost:'EUR'}}</span>
      </span>
    </div>

  </div>




  <div class="tabs-wrapper blue">
    <div class="title">
      <div class="tab-wrapper-item" [class.active]="activeTab === 1" (click)="changeTab(1)">Мои данные
      </div>
      <div class="tab-wrapper-item" [class.active]="activeTab === 2" (click)="changeTab(2)">Мои расходы
      </div>
      <span class="tab-line"></span>
    </div>
    <div class="tabs-content">


      <!--        [clientId]="clientId" (notify)="onNotify($event)"-->
      <app-client-details *ngIf="activeTab === 1" [client]="user" >
      </app-client-details>

      <app-client-travel-history *ngIf="activeTab === 2" [travels]="travels">  </app-client-travel-history>
    </div>
  </div>
</div>
